export enum AlgoLimitPrice {
  DISABLED,
  REQUIRED,
  OPTIONAL,
}

export namespace AlgoLimitPrice {
  let elements = [AlgoLimitPrice.DISABLED, AlgoLimitPrice.REQUIRED, AlgoLimitPrice.OPTIONAL];
  let alias = "com.bcdfx.model.common.api.enums.AlgoLimitPrice";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
